import { DialogTitle as MuiDialogTitle, Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Title = styled(MuiDialogTitle)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
});

export const Actions = styled(Grid)({
  display: "flex",
  gap: "15px",
});
